"use strict";
/*
 * Created on 19. 9. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var DataDictionaryError_1 = require("../../core/model/data-dictionary/DataDictionaryError");

var ValidationResultConverter_1 = require("../../core/model/errors/conversions/ValidationResultConverter");

var ValidationResult_1 = require("../../core/model/errors/ValidationResult");

var utils_1 = require("../../core/utils");

var RealImpactValueConverter_1 = require("../../impact/conversions/RealImpactValueConverter");

var ProductPriceConverter_1 = require("../../product/conversions/ProductPriceConverter");

var ProductPurchasePriceConverter_1 = require("../../product/conversions/ProductPurchasePriceConverter");

var RegularProductPriceConverter_1 = require("../../product/conversions/RegularProductPriceConverter");

var UserMessageConverter_1 = require("../../user-messages/conversions/UserMessageConverter");

var VendorAllowanceBonusConverter_1 = require("../../vendor-allowance/conversions/VendorAllowanceBonusConverter");

var ReleaseItem_1 = require("../model/ReleaseItem");

var PriceCommentConverter_1 = require("./PriceCommentConverter");

var PriceZoneReleasePricesConverter_1 = require("./PriceZoneReleasePricesConverter");

var ReleaseItemConverter_1 = require("./ReleaseItemConverter");
/**
 * Default implementation of release item converter.
 *
 * @author Radek Beran
 */


var ReleaseItemConverterImpl =
/*#__PURE__*/
function (_ReleaseItemConverter) {
  _inherits(ReleaseItemConverterImpl, _ReleaseItemConverter);

  function ReleaseItemConverterImpl(productPriceConverter, regularProductPriceConverter, priceZoneReleasePricesConverter, priceCommentConverter, vendorAllowanceBonusConverter, productPurchasePriceConverter, userMessageConverter, validationResultConverter, realImpactValueConverter) {
    var _this;

    _classCallCheck(this, ReleaseItemConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseItemConverterImpl).call(this));
    _this.productPriceConverter = productPriceConverter;
    _this.regularProductPriceConverter = regularProductPriceConverter;
    _this.priceZoneReleasePricesConverter = priceZoneReleasePricesConverter;
    _this.priceCommentConverter = priceCommentConverter;
    _this.vendorAllowanceBonusConverter = vendorAllowanceBonusConverter;
    _this.productPurchasePriceConverter = productPurchasePriceConverter;
    _this.userMessageConverter = userMessageConverter;
    _this.validationResultConverter = validationResultConverter;
    _this.realImpactValueConverter = realImpactValueConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ReleaseItemConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new ReleaseItem_1.ReleaseItem(ReleaseItem_1.ReleaseItem.schema.id.valueOf(conversions.documentToClassId(source)), ReleaseItem_1.ReleaseItem.schema.releaseId.valueOf(conversions.toClassReferenceId(source.releaseId)), ReleaseItem_1.ReleaseItem.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), ReleaseItem_1.ReleaseItem.schema.productExternalId.valueOfField(source), utils_1.Utils.isValueMissing(source.productName) ? ''
      /* Temporary default for backward compatibility, can be removed in production */
      : ReleaseItem_1.ReleaseItem.schema.productName.valueOfField(source), conversions.asObjectList(source, 'categoryIds', function (id) {
        if (utils_1.Utils.isValueMissing(id)) {
          throw new DataDictionaryError_1.DataDictionaryError("competitor site id cannot be empty!");
        }

        return conversions.toClassReferenceId(id);
      }), ReleaseItem_1.ReleaseItem.schema.exported.valueOfField(source), ReleaseItem_1.ReleaseItem.schema.exportedDate.valueOfField(source), ReleaseItem_1.ReleaseItem.schema.readonly.valueOfField(source), conversions.asObjectList(source, 'prices', function (doc) {
        return _this2.priceZoneReleasePricesConverter.toObject(doc, conversions);
      }), utils_1.Utils.isObject(source.purchasePrice) ? this.productPurchasePriceConverter.toObject(source.purchasePrice, conversions) : null, conversions.asObjectOpt(source, 'regularPrice', function (doc) {
        return _this2.regularProductPriceConverter.toObject(doc, conversions);
      }), utils_1.Utils.isObject(source.vendorAllowance) ? this.vendorAllowanceBonusConverter.toObject(source.vendorAllowance, conversions) : null, ReleaseItem_1.ReleaseItem.schema.productSensitivityId.valueOf(conversions.toClassReferenceId(source.productSensitivityId)), utils_1.Utils.isValueMissing(source.tierId) ? null : ReleaseItem_1.ReleaseItem.schema.tierId.valueOf(conversions.toClassReferenceId(source.tierId)), utils_1.Utils.isValueMissing(source.weighted) ? false : ReleaseItem_1.ReleaseItem.schema.weighted.valueOfField(source), utils_1.Utils.isValueMissing(source.fixedPrice) ? false : ReleaseItem_1.ReleaseItem.schema.fixedPrice.valueOfField(source), utils_1.Utils.isValueMissing(source.validationResult) ? ValidationResult_1.ValidationResult.EMPTY : this.validationResultConverter.toObject(source.validationResult, conversions), ReleaseItem_1.ReleaseItem.schema.uploaded.valueOfField(source), utils_1.Utils.isValueMissing(source.realImpact) ? null : this.realImpactValueConverter.toObject(source.realImpact, conversions));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      var document = {};
      Object.assign(document, conversions.classToDocumentId(source));
      Object.assign(document, {
        releaseId: conversions.toDocumentReferenceId(source.releaseId),
        productId: conversions.toDocumentReferenceId(source.productId),
        productExternalId: source.productExternalId,
        productName: source.productName,
        categoryIds: conversions.asObjectArray(source, 'categoryIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        exported: source.exported,
        exportedDate: utils_1.Utils.isMoment(source.exportedDate) ? conversions.fromDate(source.exportedDate) : null,
        readonly: source.readonly,
        prices: source.prices !== null ? conversions.asObjectArray(source, 'prices', function (field) {
          return _this3.priceZoneReleasePricesConverter.toDocument(field, conversions);
        }) : [],
        purchasePrice: source.purchasePrice !== null ? this.productPurchasePriceConverter.toDocument(source.purchasePrice, conversions) : null,
        regularPrice: source.regularPrice !== null ? this.regularProductPriceConverter.toDocument(source.regularPrice, conversions) : null,
        vendorAllowance: source.vendorAllowance !== null ? this.vendorAllowanceBonusConverter.toDocument(source.vendorAllowance, conversions) : null,
        productSensitivityId: conversions.toDocumentReferenceId(source.productSensitivityId),
        tierId: conversions.toDocumentReferenceId(source.tierId),
        weighted: source.weighted,
        fixedPrice: source.fixedPrice,
        validationResult: this.validationResultConverter.toDocument(source.validationResult, conversions),
        uploaded: source.uploaded
      });

      if (source.realImpact) {
        Object.assign(document, {
          realImpact: this.realImpactValueConverter.toDocument(source.realImpact, conversions)
        });
      }

      return document;
    }
  }]);

  return ReleaseItemConverterImpl;
}(ReleaseItemConverter_1.ReleaseItemConverter);

ReleaseItemConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __param(2, typescript_ioc_1.Inject), __param(3, typescript_ioc_1.Inject), __param(4, typescript_ioc_1.Inject), __param(5, typescript_ioc_1.Inject), __param(6, typescript_ioc_1.Inject), __param(7, typescript_ioc_1.Inject), __param(8, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ProductPriceConverter_1.ProductPriceConverter, RegularProductPriceConverter_1.RegularProductPriceConverter, PriceZoneReleasePricesConverter_1.PriceZoneReleasePricesConverter, PriceCommentConverter_1.PriceCommentConverter, VendorAllowanceBonusConverter_1.VendorAllowanceBonusConverter, ProductPurchasePriceConverter_1.ProductPurchasePriceConverter, UserMessageConverter_1.UserMessageConverter, ValidationResultConverter_1.ValidationResultConverter, RealImpactValueConverter_1.RealImpactValueConverter])], ReleaseItemConverterImpl);
exports.ReleaseItemConverterImpl = ReleaseItemConverterImpl;